import request from '@/utils/request'


// 查询动态推广列表
export function listPopularize(query) {
  return request({
    url: '/dynamics/popularize/list',
    method: 'get',
    params: query
  })
}

// 查询动态推广分页
export function pagePopularize(query) {
  return request({
    url: '/dynamics/popularize/page',
    method: 'get',
    params: query
  })
}

// 查询动态推广详细
export function getPopularize(data) {
  return request({
    url: '/dynamics/popularize/detail',
    method: 'get',
    params: data
  })
}

// 新增动态推广
export function addPopularize(data) {
  return request({
    url: '/dynamics/popularize/add',
    method: 'post',
    data: data
  })
}

// 修改动态推广
export function updatePopularize(data) {
  return request({
    url: '/dynamics/popularize/edit',
    method: 'post',
    data: data
  })
}

// 删除动态推广
export function delPopularize(data) {
  return request({
    url: '/dynamics/popularize/delete',
    method: 'post',
    data: data
  })
}
